import React, { FC } from "react";
import Button from "../customhtmlcomponents/Button";
import { ResponseData } from "../adminpanel/panels/types/types";
import axios from "../../services/ApiConfig";
import { downloadFile } from "../../utility/downloadFile";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";

interface IRapportProps {
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const Rapport: FC<IRapportProps> = ({
  currentForeningReportNumber,
  message,
  setModal,
}) => {
  const downloadRapport = () => {
    axios
      .get(`${URLS.LASTNED_RAPPORT_GET}${currentForeningReportNumber}`, {
        responseType: "blob",
      })
      .then((r) => {
        downloadFile(r, "pdf", -1, currentForeningReportNumber);
      })
      .catch((err) => console.error(err));
  };
  const saveOnClick = () => {};
  return (
    <div>
      <NavigationBar saveOnClick={saveOnClick} />
      <div>
        <p className="text-black text-center text-2xl font-bold mt-2py-2 ">
          8. Rapport
        </p>
      </div>
      <div className="flex flex-grow-0 flex-row m-auto justify-center transform scale-100 md:scale-75">
        <div className="mt-4 h-2/3 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl p-20">
          <table className="table-auto border-sk-tertiary-blue">
            <thead>
              <tr>
                <th className="w-1/4 text-2xl font-medium">
                  Rapportering er nå gjennomført og sekretariatet har mottatt din rapportering.
                  <br/><br/>
                  Du kan likevel endre eller legge til informasjon frem til databasen lukkes for rapportering 1. mars.
                  <br/><br/>
                  Dersom du ønsker å skrive ut eller laste ned rapporten din, velg "Last ned pdf" under.
                </th>
              </tr>
              <tr>
                <div className="pt-12">
                  <Button onClick={downloadRapport}>Last ned PDF</Button>
                </div>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Rapport;
